import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api from '../../utils/api';
import Spinner from '../../components/ui/Spinner';
import Button from '../../components/ui/Button';
import CareerPublicContent from '../../components/public/CareerPublicContent';
import { formatApiError } from '../../utils/errors';

export default function CareersPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    setError(null);
    api.get('/career/public')
      .then(r => setData(r.data))
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <Spinner fullPage />;

  // An outage is not the same as a careers page with nothing published: when the
  // request succeeds, CareerPublicContent renders the "no open positions" copy.
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
        <div role="alert" className="surface-panel p-8 max-w-md w-full text-center">
          <h1 className="text-lg font-semibold text-slate-900">We couldn&apos;t load our openings</h1>
          <p className="text-sm text-slate-600 mt-2">{formatApiError(error)}</p>
          <Button className="mt-5" onClick={load}>Try again</Button>
          <p className="text-sm text-slate-500 mt-6">
            Already applied?{' '}
            <Link to="/track" className="text-brand-600 font-medium hover:underline">Track your application</Link>
            {' · '}
            <Link to="/portal" className="text-brand-600 font-medium hover:underline">Candidate portal</Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <CareerPublicContent data={data} readOnly={false} />
    </div>
  );
}
